import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ToggleButton from '../ToggleButton';
import { Section, ToggleContainer, ContentWrapper } from './styles';

const AccordionItem = ({
  device,
  dataPubli,
  title,
  children,
  externalActive,
  iconTitle,
  withoutBorder,
  fontSize = '14px',
  fontWeight = '400',
  lineHeight = '24px'
}) => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (externalActive) {
      setActive(true);
    } else {
      setActive(false);
    }
  }, [externalActive]);

  return (
    <Section withoutBorder={withoutBorder}>
      <ToggleContainer
        onClick={() => setActive(!active)}
        fontSize={fontSize}
        fontWeight={fontWeight}
        lineHeight={lineHeight}
      >
        <div className='titleContainer'>
          {iconTitle && <img width='16px' height='16px' src={iconTitle} alt='tip icon' />}
          {title}
        </div>
        <ToggleButton data-publi={`${dataPubli}-chevron`} device={device} active={active} setActive={setActive} />
      </ToggleContainer>
      <ContentWrapper data-publi={`${dataPubli}-content`} active={active}>
        {children}
      </ContentWrapper>
    </Section>
  );
};

AccordionItem.propTypes = {
  title: PropTypes.string,
  device: PropTypes.string,
  dataPubli: PropTypes.string,
  children: PropTypes.node.isRequired
};

export default AccordionItem;
